import {deletePopover} from "../../../hoc/deletePopover";

const CashBoxExpenseDeleteModal = deletePopover("CashBoxExpenseDeleteModal")

export default CashBoxExpenseDeleteModal
